export default {
    'OPERACION_ETIQ': (state, mutation) => {
        state.etiqueta = mutation.etiqueta
    }
}